'use client';

import { DocumentData } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';

import { CreateContractProvider, useCreateContract } from '~/contract/hooks/useCreateContract';
import { CreateContractState } from '~/contract/hooks/useCreateContract/types';
import { MobilePageHeader, ProcessDetails, WizardLayout } from '~/ui';

import { ContractDownloadStep } from './ContractDownloadStep';
import { ContractPreviewStep } from './ContractPreviewStep';
import { ContractSignStep } from './ContractSignStep';

const STEPS = {
  download: ContractDownloadStep,
  preview: ContractPreviewStep,
  sign: ContractSignStep,
};

export const Wizard = () => {
  const { t } = useTranslation('createContractWizard');
  const { getCurrentStep, goToPreviousStep } = useCreateContract();

  const currentStep = getCurrentStep();

  const CurrentStep = STEPS[currentStep as keyof typeof STEPS] || STEPS.preview;

  const showBackButton = currentStep !== 'preview';

  return (
    <WizardLayout
      leftChild={
        <ProcessDetails
          title={t('title')}
          subtitle={t('subtitle')}
          onBackClick={goToPreviousStep}
          showBackButton={showBackButton}
        />
      }
      rightChild={<CurrentStep />}
      header={<MobilePageHeader title={t('title')} onBackClick={goToPreviousStep} showBackButton={showBackButton} />}
    />
  );
};

interface CreateContractWizardProps {
  onCompletion: () => void;
  onUpdate: (data: CreateContractState['contractData']) => void;
  onboardingData?: DocumentData | null;
}

export const CreateContractWizard = ({ onCompletion, onUpdate, onboardingData }: CreateContractWizardProps) => (
  <CreateContractProvider onCompletion={onCompletion} onUpdate={onUpdate} onboardingData={onboardingData}>
    <Wizard />
  </CreateContractProvider>
);
